import { render, staticRenderFns } from "./SetupProfileTab.vue?vue&type=template&id=2dc49be6&"
import script from "./SetupProfileTab.vue?vue&type=script&lang=js&"
export * from "./SetupProfileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports